module.exports = __webpack_public_path__ + "static/media/home-solid-r.c876d829.svg";